module.exports = __webpack_public_path__ + "img/annual_certificate_3.9ec68089.svg";